import { FC } from 'react';

import * as Styles from './buttons.styles';

type BigButtonProps = {
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  children: string;
} & React.HTMLAttributes<HTMLButtonElement>;

const BigButton: FC<BigButtonProps> = (props) => {
  return (
    <Styles.BigButton {...props} id={props.id || 'big-button'} />
  );
};

export default BigButton;
